<div class="course-items-switch-wrapper">
    <ng-container [ngSwitch]="display">
        <ng-container *ngSwitchCase="ResourceBuildingItems.EVENT_LIBRARY">
            <mat-tab-group class="res-tabs-course-item" #tabGroup ngClass.xs="xs">
                <mat-tab>
                    <ng-template mat-tab-label i18n> My events </ng-template>

                    <app-resource-library-multiple-select
                        [type_scope_id]="AppScope.EVENT"
                        context="author"
                        [selection]="selection"
                        (onSubmitMultiSelect)="onMultiSelect.emit({ res: $event, isParentSubmission: false })"
                        (selectChange)="selectChange.emit($event)"
                        ><ng-container [ngTemplateOutlet]="topSubmitBtn"></ng-container
                    ></app-resource-library-multiple-select>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label i18n> Academy events </ng-template>

                    <app-resource-library-multiple-select
                        [type_scope_id]="AppScope.EVENT"
                        context="academy"
                        [selection]="selection"
                        (onSubmitMultiSelect)="onMultiSelect.emit({ res: $event, isParentSubmission: false })"
                        (selectChange)="selectChange.emit($event)"
                        ><ng-container [ngTemplateOutlet]="topSubmitBtn"></ng-container
                    ></app-resource-library-multiple-select>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label i18n> Open library (KOL) </ng-template>

                    <app-resource-library-multiple-select
                        [type_scope_id]="AppScope.EVENT"
                        context="kol"
                        [selection]="selection"
                        (onSubmitMultiSelect)="onMultiSelect.emit({ res: $event, isParentSubmission: false })"
                        (selectChange)="selectChange.emit($event)"
                        ><ng-container [ngTemplateOutlet]="topSubmitBtn"></ng-container
                    ></app-resource-library-multiple-select>
                </mat-tab>
            </mat-tab-group>
        </ng-container>
        <ng-container *ngSwitchCase="ResourceBuildingItems.CREATE_NEW_EVENT"
            ><app-course-manager-event-create
                #compRef
                class="create-test-in-course-manager"
                [resource]="resourceToEdit"
                publishLabel="Add to course"
                i18n-publishLabel
                (saved)="add.emit($event)"
            ></app-course-manager-event-create
        ></ng-container>
    </ng-container>
    <button
        matTooltip="Trash"
        mat-icon-button
        (click)="display = null; onCloseView.emit(true)"
        i18n-matTooltip
        class="add-creation-tab"
        [ngClass]="display === ResourceBuildingItems.EVENT_LIBRARY ? 'lib' : 'normal'"
    >
        <mat-icon>cancel</mat-icon>
    </button>
</div>
<ng-template #topSubmitBtn>
    <button
        *ngIf="!!selectedResources?.length"
        class="topsubmitBtn"
        mat-button
        color="primary"
        (click)="onSubmitMultiple()"
    >
        <span i18n>Done ({{ selectedResources?.length }})</span>
    </button>
</ng-template>
